import React, { useState } from 'react';
import axios from 'axios';
import { useBusinessAuth } from '../../contexts/BusinessAuthContext';
import './AuthForms.css';

const LoginForm = ({ onSwitchToSignup }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { login } = useBusinessAuth();

  const BASE_URL = `${process.env.REACT_APP_API_URL || 'http://localhost:10000'}/api/auth`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const response = await axios.post(`${BASE_URL}/login`, {
        email,
        password,
      });

      if (response.status === 200) {
        const { token, daycare } = response.data;
        login(token, daycare);
      }
    } catch (err) {
      console.error('Login error:', err);
      if (err.response?.status === 401) {
        setError('Invalid email or password');
      } else if (err.response?.status === 403) {
        setError(err.response.data.error || 'Account is inactive');
      } else {
        setError('Login failed. Please try again.');
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-form-container">
      <h2>🐕 Login to BarkBacks</h2>
      <p className="auth-form-subtitle">Welcome back! Log in to manage your daycare videos.</p>

      <form onSubmit={handleSubmit} className="auth-form">
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your@email.com"
            required
            disabled={isSubmitting}
          />
        </div>

        <div className="form-group">
          <label>Password:</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Enter your password"
            required
            disabled={isSubmitting}
          />
        </div>

        {error && (
          <div className="error-message">
            ❌ {error}
          </div>
        )}

        <button
          type="submit"
          disabled={isSubmitting}
          className="auth-submit-button"
        >
          {isSubmitting ? '⏳ Logging in...' : '🔓 Login'}
        </button>
      </form>

      <div className="auth-switch">
        <p>
          Don't have an account?{' '}
          <button onClick={onSwitchToSignup} className="switch-link">
            Sign up here
          </button>
        </p>
      </div>
    </div>
  );
};

export default LoginForm;
